import { mergeAttributes, Node } from '@tiptap/core';

const DynamicField = Node.create({
  name: 'dynamicField',

  addOptions() {
    return {
      HTMLAttributes: {},
    };
  },

  // copied from mentions source code
  group: 'inline',
  inline: true,
  selectable: false,
  atom: true,

  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-id'),
        renderHTML: (attributes) => {
          if (!attributes.id) {
            return {};
          }

          return {
            'data-id': attributes.id,
          };
        },
      },

      label: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-label'),
        renderHTML: (attributes) => {
          if (!attributes.label) {
            return {};
          }

          return {
            'data-label': attributes.label,
          };
        },
      },

      tokenField: {
        default: null,
        parseHTML: (element) => element.getAttribute('data-field'),
        renderHTML: (attributes) => {
          if (!attributes.tokenField) {
            return {};
          }

          return {
            'data-field': attributes.tokenField,
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        // tag: `span[data-type="${this.name}"]`,
        tag: '.token', // old session notes don't have data-type
      },
    ];
  },

  renderHTML({ node, HTMLAttributes }) {
    return [
      'span',
      mergeAttributes({
        'data-type': this.name,
        'data-field': node.attrs.tokenField,
      }, HTMLAttributes, this.options.HTMLAttributes),
      // node.attrs.label,
    ];
  },

  renderText({ node }) {
    return node.attrs.label;
  },

  addCommands() {
    return {
      setDynamicField: (html) => ({ editor, commands }) => {
        editor.chain().focus().run();

        // probably not the "true" way to create new node, but it works.
        return commands.insertContent(html);
      },
    };
  },
});

export default DynamicField;
